export default __webpack_public_path__ + "static/media/aboutband_icon_02.58d66879.png";